import React from 'react';
import { DAPrice } from '@components';

const TtfDAPrice = () => {
    return (
        <DAPrice
            title="TTF DA Prices"
            rootPath="/media/files/csv/index/ttf/"
            breadcrumbRootLabel="ttf-da-prices"
            searchPlaceholders={{
                0: 'Search year folder (e.g. 2026)',
                1: 'Search month folder (e.g. 03 or March)',
                2: 'Search filename (e.g. 01.03.2026.csv)',
                default: 'Search filename or date'
            }}
            levelLabels={{
                0: 'Year',
                1: 'Month',
                2: 'File',
                default: 'Folder'
            }}
        />
    );
};

export default TtfDAPrice;
